import * as React from 'react';
import {forwardRef, useEffect, useRef, useState} from 'react';
import {FormattedMessage} from 'react-intl';

import {Tag} from "features/search/types";
import {getFlattenedTags, getSortedTagsAmount} from "@organisms/ResidenceSearch/Search/helpers";
import {TagMenuItem} from "@organisms/ResidenceSearch/Search/_tagMenuItem";
import { Margin, TextColor } from 'features/ui/enums';
import { P } from '@atoms/Text/P';

interface Props {
    activeTags: { [key: string]: Tag[] };
    searchString: string;
    onSelectTag: (tag: Tag) => void;
    emptyResult?: boolean;
}

//export const TagMenu: React.FunctionComponent<Props> = ({activeTags, searchString, onSelectTag, emptyResult}) => {
export const TagMenu = forwardRef<HTMLButtonElement, Props>(({activeTags, searchString, onSelectTag, emptyResult}, _ref) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const count = getSortedTagsAmount(activeTags);
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setActiveIndex(0);
    }, [activeTags]);

    const onKeyDown = (e:KeyboardEvent) => {
        switch (e.keyCode) {
            case 38: // Up
                e.preventDefault();
                setActiveIndex(activeIndex => activeIndex === 0 ? count - 1 : activeIndex -1);
                if(wrapperRef.current !== null) {
                    //wrapperRef.current.focus();
                }
                break;

            case 40: // Down
                e.preventDefault();
                setActiveIndex(activeIndex => activeIndex === count - 1 ? 0 : activeIndex + 1);
                if(wrapperRef.current !== null) {
                    //wrapperRef.current.focus();
                }
                break;

            case 9: // tab
                if(e.shiftKey) {
                    e.preventDefault();
                    setActiveIndex(activeIndex => activeIndex === 0 ? count - 1 : activeIndex -1);
                } else {
                    e.preventDefault();
                    setActiveIndex(activeIndex => activeIndex === count - 1 ? 0 : activeIndex + 1);
                }
                break;

            case 13: { // Enter
                e.preventDefault();
                //if(emptyResult) return;

                const tags = getFlattenedTags(activeTags);
                const tag = tags.find(x => x.index === activeIndex);

                if(tag)
                    onSelectTag(tag);
                break;
            }
        }
    };

    const onRowClick = (tag: Tag) => {
        if(tag)
            onSelectTag(tag);
    };

    useEffect(() => {
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [count, activeIndex, activeTags, onSelectTag]);

    return (
        <div className="tag-menu" data-test-id="tag-menu">
            {emptyResult &&
                <>
                    <P
                        className="tag-menu__no-result-title"
                        color={TextColor.BRAND}
                        margin={Margin.M}
                    >
                        <FormattedMessage id="jm.components.AutoCompleteMenu.searchNoHit" />
                    </P>

                    <span className="tag-menu__prompt-label">
                        <FormattedMessage id="jm.components.AutoCompleteMenu.buildingInCounties" />:
                    </span>
                </>
            }

            {Object.keys(activeTags).map((categoryName) => {
                if(activeTags[categoryName].length === 0) return null;

                return (
                    <div
                        className="tag-menu__category"
                        key={`category-${categoryName}`}
                        ref={wrapperRef}
                        tabIndex={-1}
                    >
                        {!emptyResult &&
                            <span className="tag-menu__category-name">
                                <FormattedMessage
                                    id={categoryName}
                                />
                            </span>
                        }

                        {activeTags[categoryName].map((tag) => (
                            <TagMenuItem
                                key={`item-${tag.id}`}
                                tag={tag}
                                onClick={onRowClick}
                                tabIndex={tag.index}
                                searchString={searchString}
                                active={(tag.index === activeIndex)} // && !emptyResult
                            />
                        ))}
                    </div>
                )
            })}
        </div>
    );
});
